import appConfigStoreModule from '@core/@app-config/appConfigStoreModule'
import Vue from 'vue'
import Vuex from 'vuex'
import app from './app'
import getters from './getters'
import users from './modules/users'
import sysRoleMenus from './modules/sysRoleMenus'
import lockerList from './modules/lockerList'
import course from './modules/course'
import program from './modules/program'
import programPrice from './modules/programPrice'
import courseItemList from './modules/courseItemList'
import order from './modules/order'
import promotion from './modules/promotion'
import orderType from './modules/orderType'
import system from './modules/system'
import center from './modules/center'
import sysRole from './modules/sysRole'

Vue.use(Vuex)

const store = new Vuex.Store({
  state: {},
  mutations: {},
  actions: {},
  modules: {
    appConfig: appConfigStoreModule,
    app,
    users,
    sysRoleMenus,
    lockerList,
    course,
    program,
    programPrice,
    courseItemList,
    order,
    promotion,
    orderType,
    system,
    center,
    sysRole,
  },
  getters,
})

// 奧步
export const useStore = () => store

export default store
